import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../firebase';
import { gateConsoleAccess, GateResult } from '../services/consoleAuth';

export interface ConsoleAuthState {
  loading: boolean;
  user: User | null;
  gate: GateResult | null;
}

export function useConsoleAuth(): ConsoleAuthState {
  const [state, setState] = useState<ConsoleAuthState>({
    loading: true,
    user: null,
    gate: null,
  });

  useEffect(() => {
    return onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setState({ loading: false, user: null, gate: { allowed: false, reason: 'unauthenticated' } });
        return;
      }
      const gate = await gateConsoleAccess(firebaseUser);
      setState({ loading: false, user: firebaseUser, gate });
    });
  }, []);

  return state;
}
